module.exports = "/images/vendor/desiigner-svg/svg/ui/home.svg?e5883abf2a812aa5aaef6a83110d1391";